<template>
  <div>
    <a-card>
      <div class="main-panel" style="height: 800px">
        <div style="text-align: right">
          <a-button style="" type="link" v-has="'SALESMAN_ADD'" @click="add()">
            添加
          </a-button>
          <a-dropdown :trigger="['click']">
            <a-button type="link">商务人员导入导出</a-button>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-upload
                  action="/api/salesmen/import"
                  @change="handleSuccess"
                  :before-upload="beforeAvatarUpload"
                  :showUploadList="false">
                  上传文件
                </a-upload>
              </a-menu-item>
              <!--              <a-menu-item @click="exportExcel">下载文件-->
              <!--              </a-menu-item>-->
              <a-menu-item @click="downloadExcel">下载模板
              </a-menu-item>
            </a-menu>
          </a-dropdown>

          <a-dropdown :trigger="['click']" v-has="'SALESMAN_IMPORT'">
            <a-button type="link" icon="el-icon-upload2">商务人员与客户关系导入</a-button>
            <a-menu slot="overlay">
              <a-menu-item icon="el-icon-upload">
                <a-upload
                  action="/api/import-biz-salesman-companies"
                  @change="handleSuccess"
                  :before-upload="beforeAvatarUpload"
                  :showUploadList="false">
                  <span>上传文件</span>
                </a-upload>
              </a-menu-item>
              <a-menu-item icon="el-icon-document-copy" key="down2" @click="downloadExcelRelation">下载模板
              </a-menu-item>
              <a-menu-item icon="el-icon-document-copy" key="down1" @click="salesManExport">下载文件
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <div class="main-content-wrap">
          <div class="main-operation-wrap">
            <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false">
              <a-row :gutter="20">
                <a-col :span="5">
                  <a-form-model-item label="姓名">
                    <a-input v-model="selectForm.name" placeholder="请输入姓名" clearable></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="5">
                  <a-form-model-item label="电话">
                    <a-input v-model="selectForm.telephone" placeholder="请输入电话" clearable></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="5">
                  <a-form-model-item label="邮箱">
                    <a-input v-model="selectForm.email" placeholder="请输入邮箱" clearable></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item label="权限">
                    <a-select v-model="selectForm.permission" filterable :collapse-tags="true"
                              placeholder="请输入权限" :clearable="true">
                      <a-select-option
                        v-for="item in option"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="3">
                  <a-form-model-item label=" ">
                    <a-button type="primary" icon="el-icon-search" @click="search">搜索</a-button>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
          <a-row>
            <a-col :span="24">
              <a-table :loading="table.loading"
                       :data-source="table.data"
                       :default-sort="table.sort"
                       :pagination="table.pagination"
                       @change="handleTableChange"
                       ref="table.dataRef">
                <!--                    <a-table-column type="index" title="No." width="100" :index="table_index" align="center">-->
                <!--                    </a-table-column>-->
                <a-table-column align="center" data-index="name" title="姓名" width="">
                </a-table-column>
                <a-table-column align="center" data-index="telephone" title="电话号码" width="">
                </a-table-column>
                <a-table-column align="center" data-index="email" title="邮箱" width="">
                </a-table-column>
                <a-table-column align="center" data-index="company" title="公司" width="">
                </a-table-column>
                <a-table-column align="center" data-index="remarks" title="备注" width="">
                </a-table-column>
                <a-table-column align="center" data-index="isAdminStr" title="权限" width="">
                </a-table-column>
                <a-table-column align="center" title="操作" width="350">
                  <template slot-scope="text, record">
                    <a-button @click="salesmanCompany(record)" v-has="'SALESMAN_COMPANY'" type="link" size="small">
                      绑定客户
                    </a-button>
                    <span class="spanCss" v-has="'SALESMAN_EDIT'">|</span>
                    <a-button @click="edit(record)" type="link" v-has="'SALESMAN_EDIT'" size="small">编辑</a-button>
                    <span class="spanCss" v-has="'SALESMAN_DELETE'">|</span>
                    <a-button @click="del(record)" type="link" v-has="'SALESMAN_DELETE'" size="small"
                              class="operationBtn">删除
                    </a-button>
                  </template>
                </a-table-column>
              </a-table>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-card>
    <a-modal v-model="form.visible" width="600px" @cancel="onFormCancel" @ok="onFormSave" :destroy-on-close="true">
      <salesman-edit :get-list="getList" :salesman-id="form.data.salesmanId" ref="userForm"></salesman-edit>
    </a-modal>

    <a-modal v-model="form.companyVisible" width="600px" @cancel="onFormCancel" @ok="onFormSave"
             :destroy-on-close="true">
      <salesman-company :salesman-id="form.data.salesmanId" ref="salesManCompanyRef"></salesman-company>
    </a-modal>

  </div>
</template>

<script>
import {getSalesmanList, delSalesman, getExportList} from '../../../api/salesman';
import SalesmanEdit from './SalesmanEdit';
import SalesmanCompany from './SalesmanCompany';
import {getTime} from '../../../utils/dateUtil';
import {dataFormat} from '../../../utils/formatConvert';
import {delProvince} from "../../../api/province";
import moment from "moment";

/**
 * 初始化商务人员列表数据
 */
async function getList() {
  let _this = this;
  console.log(this.table.pagination)
  let currentPage = this.table.pagination.current;
  if (_this.selectForm.name !== '' || _this.selectForm.telephone !== '' || _this.selectForm.email !== '') {
    _this.table.pagination.current = 1;
  }
  const result = await getSalesmanList({
    page: _this.table.pagination.current,
    size: _this.table.pagination.pageSize,
    name: _this.selectForm.name,
    telephone: _this.selectForm.telephone,
    email: _this.selectForm.email,
    permission: _this.selectForm.permission
  });
  if (result.code === 1200) {
    const data = result.data.salesmen;
    this.$set(this.table, 'data', data.map(x => ({
      ...x,
      isAdminStr: x.isAdmin === 0 ? '商务人员' : x.isAdmin === 1 ? '管理人员' : '客户',
    })));
    this.$set(this.table.pagination, 'total', result.data.totalCount);
    // this.table.pagination.total = result.data.totalCount;
  }
}

async function onFormSave() {
  if (this.form.visible === true) {
    await this.$refs.userForm.save();
  }
  if (this.form.companyVisible === true) {
    await this.$refs.salesManCompanyRef.save();
  }
  this.form.visible = false;
  this.form.companyVisible = false;
  this.form.data = {};
  // this.getList();
}


function onFormCancel() {
  this.form.visible = false;
  this.form.companyVisible = false;
  // this.getList();
  this.form.data = {};
}

function edit(record) {
  this.form.data.salesmanId = record.id;
  this.form.visible = true;
  this.form.companyVisible = false;
}

function add() {
  this.form.data.salesmanId = '';
  this.form.visible = true;
  this.form.companyVisible = false;
}

function del(record) {
  let that = this;
  this.$confirm({
    title: '是否删除这条数据?',
    content: '',
    okType: 'danger',
    async onOk() {
      const result = await delSalesman(record.id);
      if (result.code === 1200) {
        that.$message.success('删除成功')
        that.form.data = {};
        await that.getList();
      }
    },
    //   this.onCancel()
    onCancel() {
    },
    class:
      'test',
  });
}

/**
 * 文件上传之前的回调函数
 */
function beforeAvatarUpload(file) {
//        判断上传文件的后缀 是否为 xls 或 xlsx 格式
  const index = file.name.lastIndexOf('.');
  const fileName = file.name.substring(index + 1);
  if (fileName !== 'xls' && fileName !== 'xlsx') {
    let that = this;
    this.$confirm({
      title: '上传文件必须为 .xls 或 .xlsx 格式 ',
      content: '',
      onOk() {
        // that.form.dialogVisibleWorker = false;
      },
      //   this.onCancel()
      onCancel() {
        that.form.dialogVisibleWorker = false;
      },
      class:
        'test',
    });
    // this.$confirm('上传文件必须为 .xls 或 .xlsx 格式 ', '提示', {
    //   confirmButtonText: '确定',
    //   cancelButtonText: '取消',
    //   type: 'warning',
    // }).catch(() => {
    //   //                关闭批量上传弹窗
    //   this.form.dialogVisibleWorker = false;
    // });
    return false;
  }
}

function handleSuccess(res) {
  let that = this;
  // setTimeout(() => {
  if (this.uploadTrue) {
    if (res.file.response && res.file.response.code === 1200) {
      that.$message.success('上传成功');
      this.getList();
    }
  } else {
    this.uploadTrue = !this.uploadTrue
  }

  // }, 1000)
  // if (res.code === 1200) {
  //   const h = this.$createElement;
  //   const msg = [];
  //   // eslint-disable-next-line guard-for-in,no-restricted-syntax
  //   for (const key in res.data.map) {
  //     msg.push(h('p', key));
  //   }
  //   if (msg.length > 0) {
  //     let that = this;
  //     this.$confirm({
  //       title: h('div', msg),
  //       content: '',
  //       okType: 'danger',
  //       onOk() {
  //       },
  //       //   this.onCancel()
  //       onCancel() {
  //       },
  //       class:
  //         'test',
  //     });
  //     // this.$confirm(h('div', msg), '提示', {
  //     //   type: 'warning',
  //     //   confirmButtonText: '确认',
  //     //   cancelButtonText: '取消',
  //     // });
  //   } else {
  //     this.$message.success('上传成功')
  //     // this.$message({
  //     //   message: '上传成功',
  //     //   type: 'success',
  //     // });
  //   }
  //   this.getList();
  // }
}

function salesmanCompany(record) {
  this.form.data.salesmanId = record.id;
  this.form.visible = false;
  this.form.companyVisible = true;
}

function exportExcel() {
  require.ensure([], () => {
    const { export_json_to_excel } = require('../../../utils/Export2Excel');
    const tHeader = ['商务人员名称', '客户名称'];
    // 上面设置Excel的表格第一行的标题
    const filterVal = ['name', 'telephone'];
    // 上面的index、nickName、name是tableData里对象的属性
    const list = this.excelData; // 把data里的tableData存到list
    const data = this.formatJson(filterVal, list);
    export_json_to_excel(tHeader, data, `商务人员导出${ getTime() }`);
  });
}

function salesManExport() {
  require.ensure([], async () => {
    const {export_json_to_excel} = require('../../../utils/Export2Excel');
    const tHeader = ['商务人员名称', '人员电话', '公司', '邮箱', '备注', '客户名称', '客户号'];
    // 上面设置Excel的表格第一行的标题
    const filterVal = ['name', 'telephone', 'company', 'email', 'remark', 'companyName', 'number'];
    // 上面的index、nickName、name是tableData里对象的属性
    const resultList = await getExportList();
    const list = resultList.data.data; // 把data里的tableData存到list
    const data = this.formatJson(filterVal, list);
    export_json_to_excel(tHeader, data, `商务人员绑定${getTime()}`);
  });
}

function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]));
}

async function downloadExcel() {
  let that = this;
  this.$confirm({
    title: '是否下载商务人员导入模板.xlsx?',
    content: '',
    onOk() {
      window.location.href = '/api/signForImg/商务人员导入模板.xlsx';
    },
    onCancel() {
    },
    class:
      'test',
  });
  // this.$confirm('是否下载商务人员导入模板.xlsx？', '提示', {
  //   type: 'warning',
  //   confirmButtonText: '确认',
  //   cancelButtonText: '取消',
  // }).then(async () => {
  //   window.location.href = '/api/signForImg/商务人员导入模板.xlsx';
  // });
}

async function downloadExcelRelation() {
  this.$confirm({
    title: '是否下载客户与商务人员关系表.xlsx?',
    content: '',
    onOk() {
      window.location.href = '/api/signForImg/客户与商务人员关系表.xlsx';
    },
    onCancel() {
    },
    class:
      'test',
  });
  // this.$confirm('是否下载客户与商务人员关系表.xlsx？', '提示', {
  //   type: 'warning',
  //   confirmButtonText: '确认',
  //   cancelButtonText: '取消',
  // }).then(async () => {
  //   window.location.href = '/api/signForImg/客户与商务人员关系表.xlsx';
  // });
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getList();
}

async function search() {
  this.getList()
}

export default {
  components: {
    SalesmanEdit,
    SalesmanCompany,
  },
  methods: {
    getList,
    onFormSave,
    onFormCancel,
    edit,
    add,
    del,
    beforeAvatarUpload,
    handleSuccess,
    salesmanCompany,
    exportExcel,
    formatJson,
    downloadExcel,
    downloadExcelRelation,
    handleTableChange,
    salesManExport,
    search
  },
  data() {
    return {
      uploadTrue: true,
      excelData: [],
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '40', '50'],
          showTotal: (total, range) => `${ range[0] }-${ range[1] } of ${ total } items`,
        },
      },
      form: {
        companyVisible: false,
        visible: false,
        data: {
          salesmanId: '',
        },
      },
      excelSalesManData: [],
      option: [{ value: '0', label: '商务人员' }, { value: '1', label: '管理人员' }, { value: '2', label: '客户' }],
      selectForm: {
        name: '',
        telephone: '',
        email: '',
        permission: ''
      }
    };
  },
  async created() {
    this.getList();
    const result = await getSalesmanList({
      page: this.table.pagination.current,
      size: this.table.pagination.pageSize,
      name: this.selectForm.name,
      telephone: this.selectForm.telephone,
      email: this.selectForm.email,
      permission: this.selectForm.permission
    });
    this.excelData = result.data.salesmen;
    // this.salesManExport();
  },
};
</script>
